<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>
        {{
          (data ? "dialogs.user.titleEdit" : "dialogs.user.titleCreate")
            | translate
        }}
      </h4></nb-card-header
    >
    <nb-card-body>
      <div class="form-group row">
        <label for="name" class="label col-sm-3 col-form-label">
          {{ "input.name.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="text"
            nbInput
            fullWidth
            id="name"
            formControlName="name"
            [status]="showInputError('name') ? 'danger' : 'basic'"
          />
        </div>
      </div>
      <!--  -->
      <div class="form-group row">
        <label for="email" class="label col-sm-3 col-form-label">
          {{ "input.email.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="email"
            nbInput
            fullWidth
            id="email"
            pattern="^\S+@\S+\.\S+$"
            formControlName="email"
            [status]="showInputError('email') ? 'danger' : 'basic'"
          />
        </div>
      </div>

      <nb-form-field>
        <label for="role" class="label col-sm-3 col-form-label">
          {{ "input.role.label" | translate }}
        </label>

        <nb-select formControlName="role">
          <nb-option *ngFor="let v of roles" [value]="v">{{
            "enums.userRoles." + v | translate
          }}</nb-option>
        </nb-select>
      </nb-form-field>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
